export { default } from "./DatadogBrowserLogs";
